import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";

import CloseIcon from "../Common/CloseIcon";
import CustomTab from "../Common/CustomTab";
import EventDetailsDetails from "./EventDetailsDetails";

import { isEventGroup } from "../../utils/eventGroups";

import { eventGroups, allEvents } from "../../constants/common";

import colors from "../../assets/style/colors";
import EventDetailsNotes from "./EventDetailsNotes";
//import images from "../../assets/img/images";

const styles = {
  title: {
    padding: "8px",
  },
  titleBar: {
    zIndex: 1,
    height: "40px",
    borderBottom: "1px solid " + colors.pinkishGrey,
  },
  tabs: {
    height: "40px",
    float: "left",
    minHeight: "40px",
  },
  detailsContainer: {
    maxHeight: "calc(100vh - 300px)",
    overflow: "auto",
  },
};

const EventDetails = (props) => {
  const { classes, data, language, onClose, lov, goToEventGroup,parentEventData } = props;
  const [selectedTab, setSelectedTab] = React.useState(0);

  const type = isEventGroup(get(data, ["id"])) ? eventGroups : allEvents;

  return (
    <Grid container direction="column" wrap="nowrap" className="mainContent">
      <Grid item className={classes.title}>
        <Grid container alignItems="center">
          <Grid item style={{ marginRight: "10px" }}>
            <CloseIcon closeFunction={onClose} />
          </Grid>
          <Grid item className="text-87 bold-500">
            {type === eventGroups
              ? `${get(data, ["type", `name_${language}`])} - #${get(data, [
                  "id",
                ])}`
              : get(data, ["type", `name_${language}`])}
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ borderBottom: `1px solid ${colors.veryLighPink}` }}>
        <Tabs
          value={selectedTab}
          onChange={(e, newTab) => setSelectedTab(newTab)}
          indicatorColor="primary"
          centered
          className={classes.tabs}
        >
          <CustomTab height="40px" label={I18n.get("site_details")} />
          {/* <CustomTab height="40px" label={I18n.get("topbar_stats")} /> */}
          <CustomTab height="40px" label={I18n.get("site_notes")} />
        </Tabs>
      </Grid>
      <Grid item xs className={classes.detailsContainer}>
        {selectedTab === 0 && (
          <EventDetailsDetails
            data={data}
            language={language}
            lov={lov}
            type={type}
            goToEventGroup={goToEventGroup}
            parentEventData={parentEventData}
          />
        )}
        {selectedTab === 1 && <EventDetailsNotes data={data} type={type} />}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(EventDetails);
